export default {
  'placesAndDirections': {
    'isochrones': 'Isochrones',
    'place': 'lieu',
    'notRouteFound': 'Il n\'a pas été possible de trouver un itinéraire reliant les lieux avec le profil sélectionné',
    'notRouteFoundWithFilters': 'Impossible de trouver un itinéraire reliant les lieux avec le profil et les filtres sélectionnés',
    'noPlaceFound': 'Aucun endroit trouvé avec le contenu saisi',
    'routeReady': 'Itinéraire prêt',
    'useLocation': 'GPS',
    'addPlaceInput': 'Ajouter un lieu',
    'clearRoute': 'Effacer l\'itinéraire',
    'reverseRoute': 'inverser',
    'orderByClosestPlaces': 'Trier par lieux plus proches de votre emplacement',
    'calculatingRoute': 'En train de calculer l\'itinéraire...',
    'yourLocation': 'Votre emplacement',
    'expandAltitudeChart': 'Agrandir le graphique',
    'errorRenderingContentUploaded': 'Erreur lors du rendu du contenu téléchargé. Vérifiez le format et le contenu du fichier',
    'roundTrip': 'Route circulaire',
    'notPossibleToCalculateRoute': 'Un itinéraire n\'a pas pu être calculé en utilisant l\'un des lieux sélectionnés',
    'apiError': {
      '2000': 'Impossible d\'analyser la demande JSON',
      '2001': 'Le paramètre requis est manquant',
      '2002': 'Format de paramètre non valide',
      '2003': 'Les paramètres de route dépassent une ou plusieurs limites. N\'oubliez pas que certains évitables ont des limites, comme la longueur de l\'itinéraire et la superficie d\'un polygone à éviter qui ne doit pas dépasser 20 000 kilomètres carrés.',
      '2004': 'Les paramètres de route dépassent une ou plusieurs limites. N\'oubliez pas que la distance approximative de l\'itinéraire ne doit pas dépasser 6 000 km. Lorsque certaines options d\'itinéraire ou évitables sont utilisées, la distance approximative de l\'itinéraire ne doit pas être supérieure à 150 km.',
      '2006': 'Impossible d\'analyser la demande adressée au gestionnaire d\'exportation',
      '2007': 'Format d\'exportation non pris en charge',
      '2008': 'Élément vide',
      '2009': 'Impossible de trouver un itinéraire adapté aux lieux et aux critères spécifiés. Peut-être que le profil spécifié n\'est pas pris en charge dans cette zone/région avec le(s) filtre(s) appliqué(s).',
      '2010': 'Impossible de trouver un itinéraire adapté aux lieux et aux critères spécifiés. Peut-être le profil spécifié n\'est pas pris en charge dans cette zone/région avec le(s) filtre(s) appliqué(s).',
      '2011': 'Lors de l\'utilisation de l\'option d\'itinéraires alternatifs, il n\'est pas possible de définir des arrêts d\'itinéraire',
      '2012': 'An invalid parameter was specified. Make sure the URL is correct',
      '2099': 'Impossible de trouver un point valide après 3 essais'
    },
    'genericErrorMsg': 'Il n\'a pas été possible de calculer l\'itinéraire',
    'reorder': 'Réorganiser',
    timeoutError: 'La requête a pris trop de temps et a été abandonnée. Essayez des distances plus courtes.'
  }
}
